import { api } from "@/lib/api";

import type {
  AccountsResponse,
  Account,
  AccountScope,
  CashflowResponse,
  Me,
  NetWorthResponse,
  OpenBudgetStatus,
  Overview,
  RecurringResponse,
  RunwayReport,
  Scope,
  SpendingResponse,
  SyncResponse,
  SyncStatus,
  TransactionFilters,
  TransactionsResponse,
} from "./types";

export const getMe = () => api<Me>("/api/auth/me", { skipAuthRedirect: true });
export const requestCode = (email: string) =>
  api<{ ok: true; expiresInSeconds: number }>("/api/auth/request-code", {
    method: "POST",
    body: { email },
    skipAuthRedirect: true,
  });
export const verifyCode = (email: string, code: string) =>
  api<{ ok: true; user: { email: string } }>("/api/auth/verify", {
    method: "POST",
    body: { email, code },
    skipAuthRedirect: true,
  });
export const logout = () => api<void>("/api/auth/logout", { method: "POST", skipAuthRedirect: true });

export const getOverview = (scope: Scope, month: string) =>
  api<Overview>("/api/overview", { query: { scope, month } });
export const getAccounts = () => api<AccountsResponse>("/api/accounts");
export const patchAccountScope = (id: string, scope: AccountScope) =>
  api<Account>(`/api/accounts/${encodeURIComponent(id)}`, { method: "PATCH", body: { scope } });
export const getTransactions = (filters: TransactionFilters & { scope: Scope }) =>
  api<TransactionsResponse>("/api/transactions", { query: { ...filters } });
export const getSpendingByCategory = (scope: Scope, from: string, to: string) =>
  api<SpendingResponse>("/api/spending/categories", { query: { scope, from, to } });
export const getCashflowMonthly = (scope: Scope, months: number) =>
  api<CashflowResponse>("/api/cashflow/monthly", { query: { scope, months } });
export const getNetWorthHistory = (scope: Scope, days: number) =>
  api<NetWorthResponse>("/api/networth/history", { query: { scope, days } });
export const getRecurring = (scope: Scope) => api<RecurringResponse>("/api/recurring", { query: { scope } });
export const getRunway = (scope: Scope, span: number) => api<RunwayReport>("/api/runway", { query: { scope, span } });

export const getOpenBudgetStatus = () => api<OpenBudgetStatus>("/api/openbudget/status");
export const disconnectOpenBudget = () => api<void>("/api/openbudget/disconnect", { method: "POST" });
export const triggerSync = (body: { mode?: "incremental" | "backfill" | "full"; maxPages?: number } = {}) =>
  api<SyncResponse>("/api/sync", { method: "POST", body });
export const getSyncStatus = () => api<SyncStatus>("/api/sync/status");
